import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { combineStyles, media, mixins } from 'consumer-components';
import { BlIcon } from 'shared-react';

import { AvoidWidowText } from 'shared-react';
import * as IconButtonStyles from 'login-stylesheets/IconButton';

const styles = StyleSheet.create({
  button: combineStyles(IconButtonStyles.button, mixins.padding(16), {
    [media.mobileMedium]: {
      marginBottom: 12,
    },
    paddingLeft: '30px',
    paddingRight: '30px',
    height: '100%',
  }),
  buttonSelected: IconButtonStyles.buttonSelected,
  textWrapper: combineStyles(IconButtonStyles.textWrapper, {
    [media.mobileMedium]: {
      marginLeft: 8,
    },
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  }),
  buttonText: IconButtonStyles.buttonText,
});

export interface IconButtonBase {
  buttonId: string;
  text: string;
  selected?: boolean;
}

interface IconButtonProps extends IconButtonBase {
  onClick(Event): void;
}

export default class IconButton extends React.PureComponent<IconButtonProps> {
  render() {
    const { buttonId, text, selected, onClick } = this.props;

    return (
      <button id={buttonId} className={css([styles.button, selected && styles.buttonSelected])} onClick={onClick}>
        <div className={css(styles.textWrapper)}>
          <h2 className={css(styles.buttonText)}>
            <AvoidWidowText text={text} />
          </h2>
          <BlIcon icon="date-arrow-right" />
        </div>
      </button>
    );
  }
}
